<template>
  <div
    class="speech-recognition flex-grow-1 w-100 d-flex flex-column align-items-center"
  >
    <button class="btn btn-primary w-100 fw-bold" @click="toggleRecognition">
      {{ isListening ? "Listening..." : "🎤 Speak" }}
    </button>
    <div v-if="transcript || isListening" class="speech-overlay">
      {{ transcript || "..." }}
    </div><div class="transcript-stream">
  <div
    v-for="attempt in transcriptAttempts"
    :key="attempt.id"
    class="transcript-bubble"
  >
    {{ attempt.text }}
  </div>
</div>

  </div>
</template>

<script>
import { buildGrammarFromVerbs } from "../constants";
export default {
  name: "SpeechRecognition",
  data() {
    return {
      isListening: false,
      transcript: "",
      recognition: null,
      transcriptAttempts: [],
      lastTranscriptMap: {},
    };
  },
  mounted() {
    if (
      !("webkitSpeechRecognition" in window) &&
      !("SpeechRecognition" in window)
    ) {
      alert(
        "Your browser does not support Speech Recognition. Please use Chrome."
      );
      return;
    }


    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    const SpeechGrammarList =
      window.SpeechGrammarList || window.webkitSpeechGrammarList;

    this.recognition = new SpeechRecognition();
    this.recognition.lang = "es-ES"; // Spanish
    this.recognition.interimResults = true;
    this.recognition.maxAlternatives = 5;

    if (SpeechGrammarList) {
      const grammarList = new SpeechGrammarList();
      const grammar = buildGrammarFromVerbs(this.allVerbs);
      grammarList.addFromString(grammar, 1);
      this.recognition.grammars = grammarList;
    } else {
      console.warn("SpeechGrammarList not supported in this browser.");
    }
    this.recognition.onresult = (event) => {
      const results = Array.from(event.results[0]);

    //   console.log("Speech recognition results:", results);

      results.forEach((res) => {
        const transcript = res.transcript.trim();

        // Normalize to check for dupes
        const normalized = transcript.toLowerCase();

        // Already exists exactly
        if (
          this.transcriptAttempts.some(
            (t) => t.text.toLowerCase() === normalized
          )
        )
          return;

        // Find if it's an extension of a previous one
        const base = transcript.split(" ")[0]; // crude base word grouping
        const last = this.lastTranscriptMap[base];

        if (!last || transcript.startsWith(last)) {
          this.lastTranscriptMap[base] = transcript;

          this.transcriptAttempts.push({
            id: Date.now() + Math.random(),
            text: transcript,
          });

          setTimeout(() => {
            this.transcriptAttempts = this.transcriptAttempts.filter(
              (t) => t.text !== transcript
            );
          }, 2500);
        }
      });

      this.transcript = results[0]?.transcript || "";
      this.$emit("transcript", this.transcript);

      setTimeout(() => {
        this.transcript = "";
      }, 4000);
    };

    this.recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      this.isListening = false;
    };

    this.recognition.onend = () => {
      this.$emit("end"); // Emit an event when recognition ends
      this.isListening = false;
    };
  },
  methods: {
    toggleRecognition() {
      if (!this.recognition) return;

      if (this.isListening) {
        this.recognition.stop();
        this.isListening = false;
      } else {
        this.transcript = "";
        this.recognition.start();
        this.isListening = true;
      }
    },
  },
};
</script>

<style scoped>
.speech-recognition {
  max-width: 400px;
  margin: auto;
}
.speech-overlay {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 2rem;
  font-size: 1.25rem;
  z-index: 9999;
  pointer-events: none;
  max-width: 90vw;
  text-align: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.transcript-stream {
  position: fixed;
  bottom: 5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 0.4rem;
  z-index: 9999;
  pointer-events: none;
}

.transcript-bubble {
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 1.5rem;
  font-size: 1rem;
  animation: floatUp 2.5s ease forwards;
  max-width: 90vw;
  white-space: nowrap;
  opacity: 1;
}

@keyframes floatUp {
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: translateY(-30px);
    opacity: 0;
  }
}
</style>
